var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60172 2.41453L3.53922 7.47703C3.43367 7.58258 3.37437 7.72573 3.37437 7.875C3.37437 8.02427 3.43367 8.16742 3.53922 8.27297C3.64477 8.37852 3.78792 8.43781 3.93719 8.43781C4.08645 8.43781 4.22961 8.37852 4.33516 8.27297L8.43719 4.17023L8.43719 15.1875C8.43719 15.3367 8.49645 15.4798 8.60194 15.5852C8.70743 15.6907 8.8505 15.75 8.99969 15.75C9.14887 15.75 9.29195 15.6907 9.39743 15.5852C9.50292 15.4798 9.56219 15.3367 9.56219 15.1875L9.56219 4.17023L13.6642 8.27297C13.7698 8.37852 13.9129 8.43781 14.0622 8.43781C14.2115 8.43781 14.3546 8.37852 14.4602 8.27297C14.5657 8.16742 14.625 8.02427 14.625 7.875C14.625 7.72573 14.5657 7.58258 14.4602 7.47703L9.39766 2.41453C9.34541 2.36223 9.28338 2.32074 9.21509 2.29243C9.1468 2.26413 9.07361 2.24956 8.99969 2.24956C8.92577 2.24956 8.85257 2.26413 8.78428 2.29243C8.716 2.32074 8.65396 2.36223 8.60172 2.41453Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.267cb7857325d65c2495fa7de8dfaec9.svg";
export { ForwardRef as ReactComponent };